/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import { Adresse } from '@/types';

const validationAdresse = (
  adresse: Partial<Adresse>,
  skipPaysValidation = false,
) => {
  const errors = {
    adresse: '',
  };

  if (_.isEmpty(adresse?.libelleCodePostal)) {
    errors.adresse = 'Le code postal est obligatoire';
  }

  if (_.isEmpty(adresse?.libelleCommune)) {
    errors.adresse = 'La commune est obligatoire';
  }

  // Si on est à l'étranger, on n'est pas censés pouvoir sélectionner France dans le pays
  if (
    !skipPaysValidation
    && (adresse?.codeDepartement === '99'
      || adresse?.libelleDepartement === 'Pays et territoire étranger')
    && adresse?.libellePays === 'France'
  ) {
    errors.adresse = 'Le pays n\'est pas en corrélation avec le département';
  }

  if (!skipPaysValidation && (_.isEmpty(adresse?.libellePays) || _.isNil(adresse?.libellePays))) {
    errors.adresse = 'Le pays de rattachement est obligatoire';
  }

  if (
    _.isEmpty(adresse?.libellePays)
    && _.isEmpty(adresse?.libelleCommune)
    && _.isEmpty(adresse?.libelleCodePostal)
  ) {
    errors.adresse = 'L\'adresse est obligatoire';
  }

  return _.pickBy(errors, (value) => value !== '');
};

export default validationAdresse;